<template>
  <div class="browser-url-bar level is-mobile">
    <n-button variant="ghost" @click="refreshButtonClicked" class="refresh-button level-item is-narrow"
      ><RefreshIcon class="icon-1-3x"
    /></n-button>
    <n-text-input v-model="url" hide-label label="Current URL" class="level-item"></n-text-input>
  </div>
</template>

<script lang="ts" setup>
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import { useVModel } from '@vueuse/core';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});
const emit = defineEmits<{
  (e: 'update:modelValue', value: String): void;
  (e: 'refreshClicked'): void;
}>();
const url = useVModel(props, 'modelValue', emit);

function refreshButtonClicked() {
  emit('refreshClicked');
}
</script>

<style lang="scss" scoped>
.level {
  &.is-mobile {
    .level-item:not(:last-child) {
      margin-right: 0;
    }
  }
}

.browser-url-bar {
  background: $color-netcall-light-grey;
  padding: 0.75rem 0;
  width: 100%;
  &.level {
    margin-bottom: 0;
  }
  .btn.btn--ghost {
    color: $color-netcall-body-text;
  }
  .level-item:last-child {
    margin-right: 0.75rem;
  }
}
</style>
